import { render, staticRenderFns } from "./NotSavedModal.vue?vue&type=template&id=11704c27&"
import script from "./NotSavedModal.vue?vue&type=script&lang=ts&"
export * from "./NotSavedModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports